import {get, post, patch, del, paramsToString} from './common.js';

export function createInvite(email) {
    return post('/invites/', {email: email});
}